var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SuccessErrorMessage',{attrs:{"message":_vm.message}}),_c('div',{staticClass:"tabs-wrapper"},[_c('MessageFormTabs',{attrs:{"tabs":_vm.tabs}}),_c('NavigatingButtons',{attrs:{"active_tab_name":_vm.active_tab_name},on:{"next-tab":_vm.nextTab,"previous-tab":_vm.previousTab}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }